import React, { useEffect } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import { Modal, ModalHeader, ModalBody } from 'reactstrap';

import { hideModal } from 'redux/modal/actions';

import ModalTypes from 'constants/modalTypes';

import { intl } from 'utils/intl';

import { fetchGiftWinnersStart, setCampaignReportsState } from 'redux/reports/actions';

const GiftWinners = ({ currentModals, gift, campaignId }) => {
  const dispatch = useDispatch();

  const { giftWinners, isFetchingGiftWinners } = useSelector(state => state.reports);

  const columns = [
    {
      title: intl.formatMessage({ id: 'reports.campaign.gifts.table.winner.table.name' }),
      dataIndex: 'name',
      key: 'name',
      width: '150px',
      ellipsis: true,
      render: (_, record) => `${record.name || ''} ${record.surname || ''}`.trim(),
    },
    {
      title: intl.formatMessage({ id: 'reports.campaign.gifts.table.winner.table.phoneNumber' }),
      dataIndex: 'phone',
      key: 'phone',
      width: '150px',
      ellipsis: true,
    },
  ];

  const handleToggle = () => {
    dispatch(hideModal(ModalTypes.GIFT_WINNERS));
  };

  useEffect(() => {
    dispatch(fetchGiftWinnersStart(campaignId, gift.id));

    return () => {
      dispatch(setCampaignReportsState({ giftWinners: [] }));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal
      isOpen={Object.prototype.hasOwnProperty.call(currentModals, ModalTypes.GIFT_WINNERS)}
      toggle={handleToggle}
      centered
      scrollable
      unmountOnClose
    >
      <ModalHeader toggle={handleToggle}>
        {intl.formatMessage({ id: 'reports.campaign.gifts.table.winner.title' })}
      </ModalHeader>
      <ModalBody>
        <Table
          rowKey='id'
          tableLayout='auto'
          columns={columns}
          loading={isFetchingGiftWinners}
          dataSource={giftWinners}
          scroll={{ x: '100%', y: 380 }}
          pagination={false}
          rowClassName='table-row'
          locale={{ emptyText: intl.formatMessage({ id: 'winners.table.emptyText' }) }}
        />
      </ModalBody>
    </Modal>
  );
};

export default GiftWinners;
